import { Button, Col, Modal, Row, Space, Table, Tabs, Typography } from "antd";
import React, { useEffect, useState } from "react";
import IntlMessage from "../../components/IntlMessage";
import customersApi from "../../api/customers";
import _, { debounce } from "lodash";
import FilterBar from "../../components/FilterBar";
import useTime from "../../hooks/useTime";
import dayjs from "dayjs";
import { formatCurrency, formatNumber } from "../../helpers/helpers";
import Status from "../../components/Status";
import routesApi from "../../api/route";

const { Text } = Typography;

const ModalPassengers = ({
  open,
  onClose,
  item,
  date_from,
  date_to,
  filterRoute,
}) => {
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [reload, setReload] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order_by: "firstname",
    order_dir: "ASC",
    filter_name: ["search_type"],
    filter_value: ["order_number"],
    from_date: date_from,
    to_date: dayjs(date_from).endOf("day").toISOString(),
  });
  const [condition, setCondition] = useState({});
  const [routeData, setRouteData] = useState([]);
  const [dateTabs, setDateTabs] = useState([]);

  useEffect(() => {
    const dates = [];
    let currentDate = dayjs(date_from);
    while (currentDate.isBefore(date_to) || currentDate.isSame(date_to)) {
      dates.push(currentDate.toISOString());
      currentDate = currentDate.add(1, "day");
    }

    setDateTabs(dates);
  }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  useEffect(() => {
    async function fetchData() {
      const res = await routesApi.getDestinations(item?.route);
      setRouteData(res);
    }

    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        await customersApi.getAllByRoute(item?.id, filter).then((res) => {
          setItems(res.data);
          setTotal(res?.total);
          setLoading(false);
        });
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }

    fetchData();
  }, [filter, reload]);

  const onFilter = debounce(async (value, title, type) => {
    if (type === "search") {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : "id",
    });
  };

  const onReload = () => {
    setReload((e) => !e);
  };

  const onChangeTab = (date) => {
    setFilter((filter) => {
      return {
        ...filter,
        from_date: date,
        to_date: dayjs(date).endOf("day").toISOString(),
      };
    });
  };

  const columns = [
    {
      key: "id",
      title: <IntlMessage id="global.id" />,
      render: (_, record) => {
        return record?.id;
      },
    },
    {
      key: "firstname",
      title: <IntlMessage id="global.name" />,
      render: (_, record) => {
        return record?.firstname + " " + record?.lastname;
      },
    },
    {
      key: "telephone",
      title: <IntlMessage id="global.mobile" />,
      render: (_, record) => {
        return (
          <Space direction="vertical">
            <Text>{record?.telephone}</Text>
            {record?.email && <Text>{record?.email}</Text>}
          </Space>
        );
      },
    },

    {
      key: "order_number",
      fixed: true,
      dataIndex: "order_number",
      title: <IntlMessage id="global.reference" />,
      render: (text, record) => {
        return record.order_number;
      },
    },

    {
      key: "seat",
      fixed: true,
      dataIndex: "seat",
      title: <IntlMessage id="global.seat" />,
      render: (text, record) => {
        return formatNumber(record.seat);
      },
    },

    {
      key: "pay_method",
      dataIndex: "pay_method",
      title: <IntlMessage id="global.method" />,
      render: (text, record) => {
        return record?.pay_method;
      },
    },
    {
      key: "total",
      dataIndex: "total",
      title: <IntlMessage id="global.total" />,
      render: (text, record) => {
        return formatCurrency(Number(record.total));
      },
    },
    {
      key: "pay_status",
      dataIndex: "pay_status",
      title: <IntlMessage id="global.pay_status" />,
      render: (text, record) => {
        return <Status status={record?.pay_status?.toLowerCase()} type="pay" />;
      },
    },
  ];
  return (
    <>
      <>
        <IntlMessage id="global.routes" />:{" "}
        {routeData && routeData.length > 0 && routeData
          .map((item) => {
            return item?.title;
          })
          .join(" ~ ")}{" "}
        ({item?.start_time} ~ {item?.end_time})
      </>
      <Row gutter={[16, 16]} justify={"end"}>
        <Col>
          <Button type="primary" onClick={onReload}>
            <IntlMessage id="global.refresh" />
          </Button>
        </Col>
      </Row>
      <br />

      <Tabs defaultActiveKey={dateTabs[0]} onChange={onChangeTab}>
        {dateTabs?.map((date, index) => {
          return (
            <>
              <Tabs.TabPane tab={dayjs(date).format("YYYY-MM-DD")} key={date}>
                <FilterBar
                  filter={filter}
                  onFilter={onFilter}
                  searchType={true}
                  dataSearchType={[
                    {
                      value: "order_number",
                      label: "Reference",
                    },
                    {
                      value: "telephone",
                      label: "Phone",
                    },
                  ]}
                />
                <br />
                <Table
                  dataSource={items}
                  columns={columns}
                  tableLayout="auto"
                  loading={loading}
                  bordered
                  scroll={{ x: "max-content" }}
                  rowKey="id"
                  size="small"
                  pagination={{
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50"],
                    total: total,
                    current: filter.page,
                    pageSize: filter.limit,
                  }}
                  onChange={onChangeTable}
                />
              </Tabs.TabPane>
            </>
          );
        })}
      </Tabs>
    </>
  );
};

export default ModalPassengers;
